import * as yup from "yup";

export const schema = yup.object().shape({
    name: yup
        .string()
        .required()
        .min(3)
        .max(255),
    description: yup
        .string()
        .required()
        .min(3)
        .max(1000),
    model_name: yup
        .string()
        .required(),
    prompt_template: yup
        .string()
        .required()
        .min(3)
        .max(50000),
    questions: yup
        .array()
        .required()
        .min(1),
    terms: yup
        .array()
        .required()
        .min(1),
});